module.exports = __webpack_public_path__ + "img/img.66b0b462.png";